function messageIsEmpty(messageNode) {
    var attachmentTypes = ['photos', 'videos', 'documents', 'links', 'groups'];

    // check if every content type is an empty array
    var attachmentsEmpty = attachmentTypes
        .map(function (type) {
            return messageNode[type] || [];
        })
        .every(function (attachments) {
            return attachments.length === 0;
        });

    // We also need to check quotes and regular message content
    var otherContentEmpty = !messageNode.blockquote && !messageNode.content;

    return attachmentsEmpty && otherContentEmpty;
}

angular
    .module('tradersyard')
    .factory('messageFormFactory', [
        'graph-storage-factory',
        function ($storage) {
            var container = {};
            var attachment = {};

            var template = {
                id: 0,
                title: '',
                content: '',
                photos: [],
                videos: [],
                documents: [],
                blockquote: undefined,
                links: [],
                new: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                trash: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                progress: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                processing: 0,
            };

            return {
                template: function (data, id) {
                    var addVal = angular.copy(angular.isObject(data) ? data : {});

                    addVal = angular.extend(angular.copy(template), addVal);

                    return addVal;
                },
                append: function (data, id, save) {
                    this.template(data, id);

                    if (attachment[id] === undefined) {
                        attachment[id] = $storage.storages('message', id).query();
                    }

                    if (attachment[id]) {
                        attachment[id].then(function (response) {
                            if (response.data.state === 0) {
                                container[id] = angular.extend({}, container[id], response.data.data);

                                container[id] = angular.extend(angular.copy(template), container[id]);
                            }

                            if (save) save(container[id]);
                        });
                    }
                },
            };
        },
    ])
    .directive('messageForm', [
        '$parse',
        '$rootScope',
        'messageFormFactory',
        'graph-message-factory',
        '$flex.array',
        '$timeout',
        'MeetingManagerFactory',
        'GuidFactory',
        function ($parse, $root, $factory, $client, $array, $timeout, MeetingManagerFactory, GuidFactory) {
            return {
                scope: true,
                priority: -5,
                link: function ($scope, $element, $attr) {
                    $scope.Guid = GuidFactory.Generate();
                    $scope.onPasteContent = onPasteScreenShoot;

                    $scope.formMessage = $factory.template(undefined);

                    $scope.client = $client.entry($parse($attr.entryId)($scope));

                    $scope.$on('message:blockquote', function (event, data) {
                        if (data.place.id === $scope.Meeting.Current.id) {
                            $scope.formMessage.blockquote = data.data;
                            $root.$broadcast('message.blockquote.add', $scope.formMessage);
                        }
                    });

                    $root.$on('meeting:change', function () {
                        $scope.fn.clear();
                    });

                    $scope.$on('message:edit', function (event, data) {
                        $scope.formMessage = $factory.template(data, data.id);
                        $scope.formMessage.old_content = data.content;
                    });

                    $scope.attach = {
                        photo: function (id) {
                            $scope.attach.trigger(id, 'photo');
                        },
                        video: function (id) {
                            $scope.attach.trigger(id, 'video');
                        },
                        document: function (id) {
                            $scope.attach.trigger(id, 'document');
                        },
                        trigger: function (id, type) {
                            document.getElementById('message-' + id + '-' + type + '-input').click();
                        },
                    };

                    $scope.input = {
                        photo: {},
                        video: {},
                        document: {},
                    };

                    $scope.onKeyUpContent = function ($event) {
                        if ($event.keyCode === 13 && $event.shiftKey !== true && $event.ctrlKey !== true) {
                            $event.preventDefault();
                            $scope.fn.submit($scope.formMessage);
                        }
                    };

                    $scope.canShowMessageForm = function (currentMeeting) {
                        if ($root.me && $root.me.ban_public_posting && currentMeeting.id === 0) {
                            return false;
                        }

                        return currentMeeting && (currentMeeting.can_publish || currentMeeting.id === 0);
                    };

                    $scope.fn = {
                        submit: function (node) {
                            if ($scope.formMessage.processing > 0) {
                                return;
                            }

                            var data = angular.copy(node);

                            angular.forEach(['photos', 'videos', 'documents', 'links', 'groups'], function (space) {
                                data[space] = $scope.fn.query(data, space);
                            });

                            if (messageIsEmpty(data)) {
                                // message had no content to send - exit early
                                // otherwise server throws error and chat breaks
                                return;
                            }

                            const blockquote = data.blockquote;
                            const messageId = $scope.Meeting.Message.Id;
                            data.blockquote = data.blockquote ? data.blockquote.id : 0;

                            if (node.id === undefined || parseInt(node.id) === 0) {
                                if (blockquote && $scope.Meeting.Current.id !== blockquote.place.id) {
                                    $scope.Meeting.Message.Id = blockquote.blockquote.place.id;
                                }

                                $scope.Meeting.Message.Publish(data, $scope.Guid, function (response) {
                                    if (response.data.state === 0) {
                                        $scope.formMessage = $factory.template(undefined, 0);

                                        $scope.Meeting.Message.Id = messageId;
                                        $root.$broadcast('message:create', response.data);
                                    }
                                });
                            } else {
                                for (var type in $scope.formMessage.trash) {
                                    var trash = $scope.formMessage.trash[type];

                                    for (var i = 0; i < trash.length; i++) {
                                        var item = trash[i];

                                        $scope.client[type]($scope.formMessage.id).delete(item.id);
                                        $scope.formMessage.trash[type].splice(i, 1);
                                    }
                                }

                                $scope.client.update(data.id, data).then(function (response) {
                                    if (response.data.state === 0) {
                                        angular.forEach($parse($attr.pool)($scope), function (iterator) {
                                            if (iterator.id === data.id) angular.extend(iterator, data);
                                        });

                                        $scope.formMessage = $factory.append(data, data.id, function (data) {
                                            $scope.formMessage = data;
                                        });

                                        $scope.formMessage = $factory.template(undefined, 0);

                                        $root.$broadcast('message.update');

                                        if ($attr.after) {
                                            var phase = $scope.$parent.$$phase;
                                            if (phase == '$apply' || phase == '$digest')
                                                $scope.$parent.$eval($attr.after);
                                            else $scope.$parent.$apply($attr.after);
                                        }
                                    }
                                });
                            }
                        },
                        error: function (error) {
                            $root.$broadcast('graph-modal-show', {
                                title: 'Error',
                                content: error,
                            });
                        },
                        upload: {
                            photos: function () {
                                $scope.formMessage.processing++;
                                var photo = $scope.input.photo;
                                $root.$broadcast('message.progress.start', $scope.formMessage);
                                $scope.formMessage.progress.photos.push({
                                    name: photo.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(
                                        {
                                            name: $scope.input.photo.name,
                                            photo: $scope.input.photo.base,
                                        },
                                        'photos'
                                    )
                                    .then(function (response) {
                                        $scope.formMessage.processing--;
                                        $scope.formMessage.progress.photos = $array.$splice(
                                            $scope.formMessage.progress.photos,
                                            { name: photo.name },
                                            'name'
                                        );
                                        $root.$broadcast('message.progress.end', $scope.formMessage);

                                        if (response.data.state === 0) {
                                            var $photo = response.data.data;

                                            if (!$array.$has($scope.formMessage.photos, $photo, 'id')) {
                                                $scope.formMessage.new.photos.push($photo);
                                                $scope.formMessage.photos.push($photo);
                                            }

                                            if (
                                                $scope.formMessage.id === undefined ||
                                                parseInt($scope.formMessage.id) === 0
                                            ) {
                                                $scope.fn.submit($scope.formMessage);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.photo ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            videos: function () {
                                $scope.formMessage.processing++;

                                var fd = new FormData();
                                fd.append('video', $scope.input.video.file);
                                fd.append('name', $scope.input.video.name);

                                var video = $scope.input.video;
                                $root.$broadcast('message.progress.start', $scope.formMessage);
                                $scope.formMessage.progress.videos.push({
                                    name: video.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(fd, 'videos')
                                    .then(function (response) {
                                        $scope.formMessage.processing--;
                                        $scope.formMessage.progress.videos = $array.$splice(
                                            $scope.formMessage.progress.videos,
                                            { name: video.name },
                                            'name'
                                        );
                                        $root.$broadcast('message.progress.end', $scope.formMessage);

                                        if (response.data.state === 0) {
                                            var $video = response.data.data;

                                            if (!$array.$has($scope.formMessage.videos, $video, 'id')) {
                                                $scope.formMessage.new.videos.push($video);
                                                $scope.formMessage.videos.push($video);
                                            }

                                            if (
                                                $scope.formMessage.id === undefined ||
                                                parseInt($scope.formMessage.id) === 0
                                            ) {
                                                $scope.fn.submit($scope.formMessage);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.video ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            documents: function () {
                                $scope.formMessage.processing++;
                                var fd = new FormData();
                                fd.append('document', $scope.input.document.file);
                                fd.append('name', $scope.input.document.name);

                                var document = $scope.input.document;
                                $root.$broadcast('message.progress.start', $scope.formMessage);
                                $scope.formMessage.progress.documents.push({
                                    name: document.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(fd, 'documents')
                                    .then(function (response) {
                                        $scope.formMessage.processing--;
                                        $scope.formMessage.progress.documents = $array.$splice(
                                            $scope.formMessage.progress.documents,
                                            { name: document.name },
                                            'name'
                                        );
                                        $root.$broadcast('message.progress.end', $scope.formMessage);

                                        if (response.data.state === 0) {
                                            var $document = response.data.data;

                                            if (!$array.$has($scope.formMessage.documents, $document, 'id')) {
                                                $scope.formMessage.new.documents.push($document);
                                                $scope.formMessage.documents.push($document);
                                            }

                                            if (
                                                $scope.formMessage.id === undefined ||
                                                parseInt($scope.formMessage.id) === 0
                                            ) {
                                                $scope.fn.submit($scope.formMessage);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.document ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            links: function ($event) {
                                var part =
                                    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;

                                var clip = $event.clipboardData;

                                var url = clip
                                    ? clip.getData('text/plain')
                                    : angular.element($event.currentTarget).val();

                                if (
                                    part.test(url) &&
                                    !$array.$has($scope.formMessage.links, { address: url }, 'address')
                                ) {
                                    $scope.formMessage.processing++;

                                    $root.$broadcast('message.progress.start', $scope.formMessage);
                                    $scope.formMessage.progress.links.push({
                                        name: url,
                                    });

                                    $scope.client
                                        .links($scope.formMessage.id)
                                        .upload({
                                            link: url,
                                        })
                                        .then(function (response) {
                                            $scope.formMessage.processing--;
                                            $scope.formMessage.progress.links = $array.$splice(
                                                $scope.formMessage.progress.links,
                                                { name: url },
                                                'name'
                                            );
                                            $root.$broadcast('message.progress.end', $scope.formMessage);

                                            if (response.data.state === 0) {
                                                $scope.formMessage.links.push(response.data.data);

                                                if (
                                                    $scope.formMessage.id === undefined ||
                                                    parseInt($scope.formMessage.id) === 0
                                                ) {
                                                    $scope.fn.submit($scope.formMessage);
                                                }
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.link ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                        });
                                }
                            },
                        },
                        attach: {
                            photos: function () {
                                $scope.formMessage.processing++;
                                var photo = $scope.input.photo;
                                $scope.formMessage.progress.photos.push({
                                    name: photo.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(
                                        {
                                            name: $scope.input.photo.name,
                                            photo: $scope.input.photo.base,
                                        },
                                        'photos'
                                    )
                                    .then(function (response) {
                                        $scope.formMessage.processing--;
                                        $scope.formMessage.progress.photos = $array.$splice(
                                            $scope.formMessage.progress.photos,
                                            { name: photo.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $photo = response.data.data;

                                            if (!$array.$has($scope.formMessage.photos, $photo, 'id')) {
                                                $scope.formMessage.new.photos.push($photo);
                                                $scope.formMessage.photos.push($photo);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.photo ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                    });
                            },
                            videos: function () {
                                $scope.formMessage.processing++;
                                var video = $scope.input.video;
                                $scope.formMessage.progress.videos.push({
                                    name: video.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(
                                        {
                                            name: $scope.input.video.name,
                                            video: $scope.input.video.base,
                                        },
                                        'videos'
                                    )
                                    .then(function (response) {
                                        $scope.formMessage.progress.videos = $array.$splice(
                                            $scope.formMessage.progress.videos,
                                            { name: video.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $video = response.data.data;

                                            if (!$array.$has($scope.formMessage.videos, $video, 'id')) {
                                                $scope.formMessage.new.videos.push($video);
                                                $scope.formMessage.videos.push($video);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.video ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                        $scope.formMessage.processing--;
                                    });
                            },
                            documents: function () {
                                $scope.formMessage.processing++;
                                var fd = new FormData();
                                fd.append('document', $scope.input.document.file);
                                fd.append('name', $scope.input.document.name);

                                var document = $scope.input.document;
                                $scope.formMessage.progress.documents.push({
                                    name: document.name,
                                });

                                $scope.client
                                    .storage($scope.formMessage.id)
                                    .upload(fd, 'documents')
                                    .then(function (response) {
                                        $scope.formMessage.progress.documents = $array.$splice(
                                            $scope.formMessage.progress.documents,
                                            { name: document.name },
                                            'name'
                                        );

                                        if (response.data.state === 0) {
                                            var $document = response.data.data;

                                            if (!$array.$has($scope.formMessage.documents, $document, 'id')) {
                                                $scope.formMessage.new.documents.push($document);
                                                $scope.formMessage.documents.push($document);
                                            }
                                        } else {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Error',
                                                content:
                                                    response.data.data.document ||
                                                    'The file is too large or the format is incorrect.',
                                            });
                                        }
                                        $scope.formMessage.processing--;
                                    });
                            },
                            links: function ($event) {
                                var part =
                                    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;

                                var clip = $event.clipboardData;

                                var url = clip
                                    ? clip.getData('text/plain')
                                    : angular.element($event.currentTarget).val();

                                if (
                                    part.test(url) &&
                                    !$array.$has($scope.formMessage.links, { address: url }, 'address')
                                ) {
                                    $scope.formMessage.processing++;

                                    $scope.formMessage.progress.links.push({
                                        name: url,
                                    });

                                    $scope.client
                                        .links($scope.formMessage.id)
                                        .upload({
                                            link: url,
                                        })
                                        .then(function (response) {
                                            $scope.formMessage.progress.links = $array.$splice(
                                                $scope.formMessage.progress.links,
                                                { name: url },
                                                'name'
                                            );

                                            if (response.data.state === 0) {
                                                $scope.formMessage.links.push(response.data.data);
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.link ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formMessage.processing--;
                                        });
                                }
                            },
                        },
                        detach: {
                            blockquote: function () {
                                $scope.formMessage.blockquote = undefined;
                                $root.$broadcast('message.blockquote.del', $scope.formMessage);
                            },
                            photos: function (photo) {
                                $scope.formMessage.photos = $array.$splice($scope.formMessage.photos, photo, 'id');

                                $scope.formMessage.new.photos = $array.$splice(
                                    $scope.formMessage.new.photos,
                                    photo,
                                    'id'
                                );

                                if ($scope.formMessage.id === 0) {
                                    $scope.client.photos($scope.formMessage.id).delete(photo.id);
                                } else {
                                    $scope.formMessage.trash.photos.push(photo);
                                }
                            },
                            videos: function (video) {
                                $scope.formMessage.videos = $array.$splice($scope.formMessage.videos, video, 'id');

                                $scope.formMessage.new.videos = $array.$splice(
                                    $scope.formMessage.new.videos,
                                    video,
                                    'id'
                                );
                                if ($scope.formMessage.id === 0) {
                                    $scope.client.videos($scope.formMessage.id).delete(video.id);
                                } else {
                                    $scope.formMessage.trash.videos.push(video);
                                }
                            },
                            documents: function (document) {
                                $scope.formMessage.documents = $array.$splice(
                                    $scope.formMessage.documents,
                                    document,
                                    'id'
                                );

                                $scope.formMessage.new.documents = $array.$splice(
                                    $scope.formMessage.new.documents,
                                    document,
                                    'id'
                                );
                                if ($scope.formMessage.id === 0) {
                                    $scope.client.documents($scope.formMessage.id).delete(document.id);
                                } else {
                                    $scope.formMessage.trash.documents.push(document);
                                }
                            },
                            links: function (link) {
                                $scope.formMessage.links = $array.$splice($scope.formMessage.links, link, 'id');

                                $scope.formMessage.new.links = $array.$splice($scope.formMessage.new.links, link, 'id');
                                if ($scope.formMessage.id === 0) {
                                    $scope.client.links($scope.formMessage.id).delete(link.id);
                                } else {
                                    $scope.formMessage.trash.links.push(link);
                                }
                            },
                        },
                        cancel: function () {
                            if ($scope.formMessage.processing > 0) return;

                            for (var type in $scope.formMessage.new) {
                                var attachment = $scope.formMessage.new[type];

                                for (var i = 0; i < attachment.length; i++) {
                                    var attach = attachment[i];

                                    $scope.fn.detach[type](attach);
                                    $scope.formMessage.new[type].splice(i, 1);
                                }
                            }

                            for (type in $scope.formMessage.trash) {
                                var trash = $scope.formMessage.trash[type];

                                for (var j = 0; j < trash.length; j++) {
                                    var item = trash[j];

                                    $scope.formMessage[type].push(item);
                                    $scope.formMessage.trash[type].splice(j, 1);
                                }
                            }

                            if ($attr.after) {
                                var phase = $scope.$parent.$$phase;
                                if (phase == '$apply' || phase == '$digest') $scope.$parent.$eval($attr.after);
                                else $scope.$parent.$apply($attr.after);
                            }
                        },
                        query: function (data, key) {
                            var values = [];

                            angular.forEach(data[key], function (item) {
                                values.push(angular.isObject(item) ? item.id : item);
                            });

                            return values;
                        },
                        clear: function () {
                            $scope.formMessage = $factory.template(undefined, 0);
                        },
                    };

                    function onPasteScreenShoot(e) {
                        for (var i = 0; i < e.originalEvent.clipboardData.items.length; i++) {
                            var item = e.originalEvent.clipboardData.items[i];

                            if (item.type.indexOf('image') !== -1) {
                                e.preventDefault();

                                $scope.imageFile = item.getAsFile();

                                var fileReader = new FileReader();
                                fileReader.onload = callbackOnloadScreenShoot;
                                fileReader.readAsDataURL($scope.imageFile);
                            } else {
                                console.log('Discarding non-image paste data');
                            }
                        }
                    }

                    function callbackOnloadScreenShoot(reader) {
                        if (reader.target.readyState === 2) {
                            $scope.input.photo = {
                                name: $scope.imageFile.name,
                                base: reader.target.result,
                            };

                            $scope.fn.upload.photos();
                        }
                    }
                },
            };
        },
    ]);
